import Banner from 'components/Banner';
import CareerForm from 'components/FormSection/Forms/CareerForm';
import { labels } from 'components/JobCards/mockData';
import JobLabels from 'components/JobLabels';
import TextWithIcon from 'components/TextWithIcon';
import jobBanner from 'images/job-banner.jpg';

const DetailedJob = () => (
    <>
        <Banner image={jobBanner} buttonText="Apply for a job">
            <h2>Chief accountant</h2>
            <JobLabels data={labels} />
            <TextWithIcon iconName="calendar" text={'25.08.2023'} />
        </Banner>

        <article className="article-content">
            <h4>
                We are an international company that develops and implements innovative technologies in agriculture. We
                are headquartered in Germany and have operations in several European countries.
            </h4>
            <p>
                Our mission is a rich, healthy and environmentally friendly harvest for our customers, while taking care
                of nature and conscious, responsible and safe agriculture. Therefore, all our products and developments
                meet these requirements.
            </p>
            <p>
                Due to the development of the company, we are opening a vacancy for a Chief Accountant in Kyiv
                (full-time).
            </p>
            <hr />
            <h5>What you will need to do:</h5>
            <ul>
                <li>
                    <p>
                        organize and maintain records: accounting, tax and financial and economic activities of the
                        company;
                    </p>
                </li>
                <li>
                    <p>
                        prepare and submit accounting, tax, financial statistical reports and other reports in
                        accordance with the requirements of the law;
                    </p>
                </li>
                <li>
                    <p>participate in the company's projects related to accounting, management and tax accounting;</p>
                </li>
                <li>
                    <p>interact with external regulatory authorities, undergo tax and audit inspections;</p>
                </li>
                <li>
                    <p>coordinate the work of the accounting department;</p>
                </li>
                <li>
                    <p>to be responsible for the following areas: sales, VAT accounting, goods accounting.</p>
                </li>
            </ul>
            <hr />
            <h5>We invite you to an interview if:</h5>
            <ul>
                <li>
                    <p>have a higher economic education;</p>
                </li>
                <li>
                    <p>reside in Kyiv or are willing to relocate and work in an office in Kyiv;</p>
                </li>
                <li>
                    <p>have at least 3 years of experience as a chief accountant (deputy chief accountant);</p>
                </li>
                <li>
                    <p>you have excellent knowledge and practical experience of UAS, IFRS;</p>
                </li>
                <li>
                    <p>have worked with foreign trade;</p>
                </li>
                <li>
                    <p>know all areas of accounting and tax legislation;</p>
                </li>
                <li>
                    <p>have a PC at the level of a confident user, work in 1C 8.3 EMS, Excel, M.E.Doc;</p>
                </li>
                <li>
                    <p>have practical experience in organizing and conducting an annual international audit; </p>
                </li>
                <li>
                    <p>management accounting, implementation, modernization and improvement of ERP systems;</p>
                </li>
                <li>
                    <p>knowledge of foreign languages (English or German): intermediate level and above.</p>
                </li>
            </ul>
            <hr />
            <h5>
                You will feel very comfortable in our team if you share our values and have the following qualities:
            </h5>
            <ul>
                <li>
                    <p>
                        predictable and understandable work schedule. We do not welcome fuss, so we prefer clear
                        planning and work-life balance;
                    </p>
                </li>
                <li>
                    <p>
                        a decent level of salary. Official, stable, and it is clear how it is calculated and paid. The
                        starting level depends on basic education, professional experience and knowledge;
                    </p>
                </li>
                <li>
                    <p>
                        we pay a bonus for achievements in addition to a fixed monthly salary if your contribution
                        improves the company's business results;
                    </p>
                </li>
                <li>
                    <p>training and professional courses in different countries to make you an even better expert;</p>
                </li>
                <li>
                    <p>high-end medical insurance, which is fully paid for by the company;</p>
                </li>
                <li>
                    <p>
                        high-quality workflow support. Each team member has a high-quality and fast smartphone and
                        laptop, and other gadgets that are necessary for professional activities. We work with licensed
                        programs. We have a very nice and comfortable office;
                    </p>
                </li>
                <li>
                    <p>we have a very positive atmosphere for work. We appreciate and respect each other;</p>
                </li>
                <li>
                    <p>
                        everyone can express their ideas and advice without any anxiety. Our managers are open and
                        sociable, and you can approach them directly;{' '}
                    </p>
                </li>
                <li>
                    <p>
                        two-week paid New Year and Christmas holidays in addition to annual leave so you can spend more
                        time with your family.
                    </p>
                </li>
            </ul>
            <hr />
            <h5>If you are interested in the offered vacancy, please send an e-mail:</h5>
            <ol>
                <li>
                    <p>Your CV;</p>
                </li>
                <li>
                    <p>Scanned copies of university diplomas and other important certificates;</p>
                </li>
                <li>
                    <p>
                        Cover letter, in which please explain why your candidacy is the best fit for this position in
                        the company. Please also indicate a possible start date and desired salary;
                    </p>
                </li>
                <li>
                    <p>
                        If you have them, send letters of recommendation, for example, from your supervisor or former
                        employer.
                    </p>
                </li>
            </ol>
            <blockquote>Don't miss the chance to be part of something exceptional – apply now!</blockquote>
        </article>
        <CareerForm />
    </>
);

export default DetailedJob;
